import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { ClinicTicketsQuery, ClinicTicketsQueryVariables } from '@/shared/api';
import CLINIC_TICKETS from '../queries/clinicTickets';

/**
 * Loads a page of clinic support tickets for the support list. Queries CLINIC_TICKETS with the filter and page limit and unwraps the clinicTickets field through the shared error handler.
 *
 * @param filter - Filter criteria for the tickets to load.
 * @param limit - Maximum number of tickets to return.
 * @returns Promise resolving to the clinic tickets.
 */
const fetchClinicTickets = async (
  filter: ClinicTicketsQueryVariables['filter'],
  limit: number = 10,
): Promise<ClinicTicketsQuery['clinicTickets']> => {
  const client = createClient();
  const result = await client.query<ClinicTicketsQuery, ClinicTicketsQueryVariables>({
    query: CLINIC_TICKETS,
    variables: {
      filter,
      limit,
    },
  });
  return handleErrorApi(result, 'clinicTickets');
};

export default fetchClinicTickets;
